import { Page } from '@optools/components/layout/page';
import { authorizedRouteLoader } from '@optools/utils/auth/authorized-route-loader';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/user-lookup')({
  beforeLoad: authorizedRouteLoader('userLookup'),
  component: RouteComponent,
});

export function RouteComponent() {
  return <Page title="User Lookup" />;
}
